<template>
  <el-header height="52px"
             class="layout-header">
    <div class="layout-header-menu">
      <el-menu :default-active="defaultActive"
               v-if="menuLayout === 2"
               mode="horizontal">
        <el-menu-item :index="item.funcAddress"
                      v-for="item in menu"
                      @click="openUrl(item.funcAddress)"
                      :key="item.funcAddress">{{ item.menuName }}</el-menu-item>
        <!-- <ent-service-menu /> -->
      </el-menu>
    </div>
    <div class="user">
      <tag-search-form v-if="userPermission.ENT ||userPermission.OPERATE "
                       :vendorId="userInfo.orgId" />
      <span class="name"
            v-if="userPermission.SUPERVISE">{{userDetail.regulatorName}}</span>
      <span class="name"
            v-if="userPermission.ENT">{{userDetail.vendorName}}</span>
      <el-dropdown trigger='click'>
        <span class="el-dropdown-link">{{userInfo.account}}<i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item v-if="userPermission.ENT"
                            @click.native="entInfo">企业信息</el-dropdown-item>
          <el-dropdown-item @click.native="updatePwd">修改密码</el-dropdown-item>
          <el-dropdown-item @click.native="logout">退出登陆</el-dropdown-item>
          <el-dropdown-item v-if="userPermission.SUPERVISE"
                            @click.native="updateSup">机构信息</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <password-modal :account="userInfo.account"
                    ref="modal"
                    :callback="logout" />
    <!-- <supervise-modal ref="sup" /> -->
  </el-header>
</template>
<script>
import PasswordModal from './password-modal.vue'
import TagSearchForm from './tag-search-form.vue'
// import SuperviseModal from './supervise-modal.vue'
// import EntServiceMenu from './ent-service-menu.vue'
import { mapState } from 'vuex'
export default {
  name: 'layout-header',
  components: { PasswordModal, TagSearchForm },
  data () {
    return {}
  },
  computed: {
    ...mapState({
      userInfo: state => state.account.userInfo,
      userPermission: state => state.account.permission,
      userDetail: state => state.account.userDetail,
      menu: state => state.account.menu,
      menuLayout: state => state.account.menuLayout
    }),
    defaultActive ({ $route }) {
      console.log($route)
      return $route.meta.topActivePath
    }
  },
  methods: {
    openUrl (url) {
      this.$store.commit('common/resetQuery', {})
      this.$router.push(url)
    },
    logout () {
      this.$store.dispatch('account/logout', {
        payload: {},
        success: () => {
          const localLoginPath = localStorage.getItem('zs.loginPath') || 'login'
          this.$router.push({ path: '/' + localLoginPath })
        }
      })
    },
    entInfo () {
      this.$router.push('/ent?vendorId=' + this.userInfo.orgId)
    },
    updatePwd () {
      this.$refs.modal.toggleModal(true)
    },
    updateSup () {
      // this.$refs.sup.fetchSupervise(this.userInfo.orgId)
      this.$router.push('/supervise-detail?regulatorId=' + this.userInfo.orgId)
    }
  },
  mounted () { }
}
</script>
<style lang="stylus" scoped>
.layout-header {
  padding: 0 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-shadow: 0 0 6px rgba(0, 21, 41, 0.2);
  z-index: 9;

  .layout-header-menu {
    flex: 1;
  }

  .name {
    font-size: 14px;
    margin: 0 10px;
  }

  .user {
    display: flex;
    align-items: center;

    .el-dropdown-link {
      cursor: pointer;
      color: #333;
    }
  }
}
</style>
<style lang="stylus">
.layout-header-menu {
  .el-menu-item {
    font-weight: 600;
    font-size: 16px;
    height: 52px;
    line-height: 52px;
  }
}
</style>
